import { MRT_ColumnDef } from "material-react-table";
import { useMemo } from "react";
import { AlertSeverityEnum, MaterialTransferido } from "../interfaces";
import { Box, Chip, IconButton, Tooltip } from "@mui/material";
import { Delete } from "@mui/icons-material";
import QrCode2Icon from '@mui/icons-material/QrCode2';
import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import { useUiStore } from "@/store/ui";
import CustomCantidadInput from "../components/ui/CustomCantidadInput";
import { cellStockProductoMetros } from "../utils";
import ButtonSeries from "../components/ui/ButtonSeries/ButtonSeries";
export const useTableColumnsInventarioSerie = () => {

  const handleActualizarProducto = useCargarSeriesProductos(s => s.handleActualizarProducto)
  const handleEliminarProducto = useCargarSeriesProductos(s => s.handleEliminarProducto)
  const setOpenModalSeries = useCargarSeriesProductos(s => s.setOpenModalSeries)
  const setAuxRow = useCargarSeriesProductos(s => s.setAuxRow)
  const setAlert = useUiStore(s => s.setAlert);

  const columnsInfoProducto = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [
    {
      accessorKey: "codigo",
      header: "Código",
    },
    /* {
      accessorKey: "producto_data.stock_actual",
      header: "Stock actual",
      Cell: ({ row }) => {

        return <Chip
          color={row.original.producto_data?.stock_actual != 0
            ? 'success'
            : 'error'}
          label={row.original.producto_data?.stock_actual}
        />
      }
    }, */

    {
      accessorKey: "metros_actuales",
      header: "Stock actual",
      Cell: ({ row }) => {

        return cellStockProductoMetros(row.original)
        /*  return row.original.producto_data?.usa_metros
           ? row.original.producto_data.stock_actual
           : row.original.metros_actuales */
        /* return <Chip
          color={row.original.metros_actuales != 0
            ? 'success'
            : 'error'}
          label={row.original.metros_actuales}
        /> */
      }
    },
    {
      accessorKey: "producto_data.descripcion",
      header: "Descripcion",
    },
    {
      accessorKey: "producto_data.categoria_producto",
      header: "Categoria producto",
    },
    /* {
      accessorKey: "producto_data.subcategoria_producto",
      header: "Subcategoria producto",
    }, */
  ], [])

  const columnsTrasladoInventario = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [
    {
      accessorKey: 'accion',
      header: 'Accion',
      size: 100,
      Cell: ({ row }) => (
        <IconButton
          onClick={() => handleEliminarProducto(row.original.id)}
        >
          <Delete />
        </IconButton>
      )
    },
    {
      accessorKey: "cantidad",
      header: "Cantidad",
      size: 125,
      Cell: ({ row }) => (
        <CustomCantidadInput<MaterialTransferido>
          disabled={row.original.producto_data?.stock_actual == 0}
          value={row.original.cantidad}
          handleValue={(value) => {
            if (parseFloat(value) > (row.original.producto_data?.stock_actual || 0))
              return setAlert(true, 'El valor que intenta ingresar supera el stock actual.', AlertSeverityEnum.error);
            handleActualizarProducto(row.original.id, {
              ...row.original,
              cantidad: value,
            })
          }}
          row={row}
        />
      ),
    },
    /* {
      accessorKey: 'contiene_series',
      header: 'Contiene',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {
        return <Checkbox
          disabled={row.original.producto_data?.stock_actual == 0}
          value={row.original.contiene_serie ?? false}
          inputProps={{ 'aria-label': 'controlled' }}
          checked={row.original.contiene_serie ?? false}
          onChange={e => {

            handleActualizarProducto(row.original.id, {
              ...row.original,
              contiene_serie: e.target.checked,
            })
          }
          }
        />
      }
    }, */
    {
      accessorKey: 'series',
      header: 'Series',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {

        const original = row.original

        const {
          contiene_serie,
          producto_data
        } = original

        return (
          <ButtonSeries
            disabled={producto_data?.stock_actual == 0 || !contiene_serie}
            onClick={() => {
              if (!contiene_serie)
                return setAlert(true, 'Seleccionar la opcion de habilitar serie.', AlertSeverityEnum.info);


              setOpenModalSeries(true);
              setAuxRow(row.original)
            }}
          />
        )

      }
    },
    ...columnsInfoProducto
  ], [])


  
  const columnsMaterialesTecnicos = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [
    {
      accessorKey: 'accion',
      header: 'Accion',
      size: 100,
      Cell: ({ row }) => (
        <IconButton
          onClick={() => handleEliminarProducto(row.original.id)}
        >
          <Delete />
        </IconButton>
      )
    },
    {
      accessorKey: "cantidad",
      header: "Cantidad",
      size: 125,
      Cell: ({ row }) => (
        <CustomCantidadInput<MaterialTransferido>
          disabled={row.original.producto_data?.stock_actual == 0}
          value={row.original.cantidad}
          handleValue={(value) => {
            if (parseFloat(value) > (row.original.producto_data?.stock_actual || 0))
              return setAlert(true, 'El valor que intenta ingresar supera el stock actual.', AlertSeverityEnum.error);
            handleActualizarProducto(row.original.id, {
              ...row.original,
              cantidad: value,
            })
          }}
          row={row}
        />
      ),
    },
    {
      accessorKey: 'series',
      header: 'Series',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {

        const original = row.original

        const {
          contiene_serie,
          producto_data
        } = original

        return (
          <ButtonSeries
            disabled={producto_data?.stock_actual == 0 || !contiene_serie}
            onClick={() => {
              if (!contiene_serie)
                return setAlert(true, 'Seleccionar la opcion de habilitar serie.', AlertSeverityEnum.info);


              setOpenModalSeries(true);
              setAuxRow(row.original)
            }}
          />
        )

      }
    },
    {
      accessorKey: "codigo",
      header: "Código",
    },
    {
      accessorKey: "producto_data.descripcion",
      header: "Descripcion",
    },
    {
      accessorKey: "producto_data.categoria_producto",
      header: "Categoria producto",
    },


  ], [])


  const columnsIngresoProducto = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [
    {
      accessorKey: 'accion',
      header: 'Accion',
      size: 100,
      Cell: ({ row }) => (
        <IconButton
          onClick={() => handleEliminarProducto(row.original.id)}
        >
          <Delete />
        </IconButton>
      )
    },
    {
      accessorKey: "cantidad",
      header: "Cantidad",
      size: 125,
      Cell: ({ row }) => (
        <CustomCantidadInput<MaterialTransferido>
          //disabled={row.original.producto_data?.stock_actual == 0}
          value={row.original.cantidad}
          handleValue={(value) => {
            handleActualizarProducto(row.original.id, {
              ...row.original,
              cantidad: value,
            })
          }}
          row={row}
        />
      ),
    },
    /* {
      accessorKey: 'contiene_series',
      header: 'Contiene',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {
        return <Checkbox
          //disabled={row.original.producto_data?.stock_actual == 0}
          value={row.original.contiene_serie ?? false}
          inputProps={{ 'aria-label': 'controlled' }}
          checked={row.original.contiene_serie ?? false}
          onChange={e => {

            handleActualizarProducto(row.original.id, {
              ...row.original,
              contiene_serie: e.target.checked,
            })
          }
          }
        />
      }
    }, */
    {
      accessorKey: 'series',
      header: 'Series',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {

        const original = row.original

        const {
          contiene_serie
        } = original

        return (
          <ButtonSeries
            disabled={!contiene_serie}
            onClick={() => {
              if (!contiene_serie)
                return setAlert(true, 'Seleccionar la opcion de habilitar serie.', AlertSeverityEnum.info);

              setOpenModalSeries(true);
              setAuxRow(original)
            }}
          />
        )
      }
    },
    {
      accessorKey: "codigo",
      header: "Código",
    },
    {
      id: 'stock_actual',
      accessorKey: "producto_data.stock_actual",
      header: "Stock Ubicación",
      Cell: ({ row }) => {

        return <Chip
          color={row.original.producto_data?.stock_actual != 0
            ? 'success'
            : 'error'}
          label={row.original.producto_data?.stock_actual}
        />
      }
    },

    /* {
      id: 'stock_ubicación',
      accessorKey: "producto_data.stock_ubicación",
      header: "Stock Ubicacion",
    }, */

    {
      accessorKey: "producto_data.descripcion",
      header: "Descripcion",
    },
    {
      accessorKey: "producto_data.categoria_producto",
      header: "Categoria producto",
    },
    {
      accessorKey: "producto_data.subcategoria_producto",
      header: "Subcategoria producto",
    },
  ], [])

  const columnsSolicitudTransferenciaInventario = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [
    {
      accessorKey: 'accion',
      header: 'Accion',
      size: 100,
      Cell: ({ row }) => (
        <IconButton
          onClick={() => handleEliminarProducto(row.original.id)}
        >
          <Delete />
        </IconButton>
      )
    },
    {
      accessorKey: "cantidad",
      header: "Cantidad",
      size: 125,
      Cell: ({ row }) => (
        <CustomCantidadInput<MaterialTransferido>
          value={row.original.cantidad}
          handleValue={(value) => {
            handleActualizarProducto(row.original.id, {
              ...row.original,
              cantidad: value,
            })
          }}
          row={row}
        />
      ),
    },
    ...columnsInfoProducto
  ], [])


  const columnsRevisarSolicitudTransferencia = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [
    {
      accessorKey: "cantidad",
      header: "cantidad",
    },
    {
      accessorKey: "codigo",
      header: "Código",
    },
    {
      accessorKey: "producto_data.stock_actual",
      header: "Stock actual",
    },
    {
      accessorKey: "producto_data.descripcion",
      header: "Descripcion",
    },
    {
      accessorKey: "producto_data.categoria_producto",
      header: "categoria_producto",
    },
    {
      accessorKey: "producto_data.subcategoria_producto",
      header: "subcategoria_producto",
    },
  ], [])

  const columnsTrasladoInventarioPorSolc = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [
    /* {
      accessorKey: 'contiene_series',
      header: 'Contiene',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {
        return <Checkbox
          value={row.original.contiene_serie ?? false}
          inputProps={{ 'aria-label': 'controlled' }}
          checked={row.original.contiene_serie ?? false}
          onChange={e => {

            handleActualizarProducto(row.original.id, {
              ...row.original,
              contiene_serie: e.target.checked,
            })
          }
          }
        />
      }
    }, */
    {
      accessorKey: 'series',
      header: 'Series',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {

        const original = row.original

        const {
          contiene_serie,
        } = original

        return (
          <ButtonSeries
            disabled={!contiene_serie}
            onClick={() => {
              if (!contiene_serie)
                return setAlert(true, 'Seleccionar la opcion de habilitar serie.', AlertSeverityEnum.info);

              setOpenModalSeries(true);
              setAuxRow(original)
            }}
          />
        )

      }
    },
    {
      accessorKey: "cantidad",
      header: "cantidad",
    },
    ...columnsInfoProducto
  ], [])

  const columnsRecepcionTransferenciaInventario = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(() => [
    /* {
      accessorKey: 'documento',
      header: 'Documento',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {
        return <IconButton
          color="primary"
          onClick={()=>{

          }}
        >
          <CloudDownloadIcon />
        </IconButton>
      }
    }, */
    {
      accessorKey: 'series',
      header: 'Series',
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }) => {


        return (
          <Box sx={{ display: 'flex', gap: '1rem' }
          }>
            <Tooltip title="Cargar Series" >
              <IconButton
                disabled={!row.original.contiene_serie}
                sx={{
                  opacity: !row.original.contiene_serie ? 0.5 : 1,
                }}
                onClick={() => {

                  if (!row.original.contiene_serie)
                    return setAlert(true, 'Seleccionar la opcion de habilitar serie.', AlertSeverityEnum.info);

                  setOpenModalSeries(true);
                  setAuxRow(row.original)
                }}
              >
                <QrCode2Icon color="primary" />
              </IconButton>
            </Tooltip>
          </Box>
        );
      }
    },
    {
      accessorKey: "cantidad_esperada",
      header: "C. Esperada",
    },

    {
      accessorKey: "cantidad_recibida",
      header: "C. Recibido",
      Cell: ({ row }) => (
        <CustomCantidadInput<MaterialTransferido>
          value={row.original.cantidad_recibida ?? '0'}
          handleValue={(value) => {
            handleActualizarProducto(row.original.id, {
              ...row.original,
              cantidad_recibida: value,
              cantidad_acumulada_temp: Number(row.original.cantidad_acumulada) + Number(value)
            })
          }}
          row={row}
        />
      ),
    },
    {
      accessorKey: "cantidad_acumulada_temp",
      header: "C. Parcial Recibido",

      Cell: ({ row }) => {
        return <Chip
          color={row.original.cantidad_esperada == row.original.cantidad_acumulada_temp ? 'success' : 'default'}
          label={row.original.cantidad_acumulada_temp}
        />
      }
      /* Cell: ({ row }) => {
        return <span
          style={{
            backgroundColor: row.original.cantidad_esperada == row.original.cantidad_acumulada_temp ? 'green' : undefined,
            padding: '0.5rem',
            width: '50px'
          }}
        >
          {row.original.cantidad_acumulada_temp}
        </span>
      } */
    },

    ...columnsInfoProducto
  ], [])

  return {
    columnsIngresoInventario: columnsTrasladoInventario,
    columnsMaterialesTecnicos,
    columnsSolicitudTransferenciaInventario,
    columnsRevisarSolicitudTransferencia,
    columnsTrasladoInventarioPorSolc,
    columnsRecepcionTransferenciaInventario,
    columnsIngresoProducto
  }


}